export default __webpack_public_path__ + "static/media/cl13.389fd841.webp";